import React from 'react';
import { useSelector } from 'react-redux';
import PageItem from './Breadcrumb.section';
import { goHome } from './services/goHome';

const BreadcrumbCustom = () => {
  const workspaces = useSelector((state: any) => state.workspaces);
  const activeInstance = workspaces.instances.find(instance => instance.isActive);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const length = activeInstance?.breadcrumb.historyPages.length ?? 0;

  return (
    <nav
      className="bg-white flex items-center gap-2 px-4 pt-6 pb-4 text-sm text-gray-700
             overflow-hidden whitespace-nowrap text-ellipsis
             font-sans max-w-full border  border-white rounded-tr-md"
      aria-label="Breadcrumb"
      style={{ maxWidth: 'calc(100% - 12px)', fontFamily: 'Arial, Helvetica, sans-serif' }}
    >
      <button onClick={goHome}  className="flex items-center gap-2 text-gray-500 hover:underline pb-1">
        <div className="e-icons e-home e-medium" />
      </button>

      {activeInstance?.breadcrumb.shiftHelper?.length >= 1 && (
        <>
          <span className="e-icons e-chevron-right text-gray-400 text-xs" />
          <span className="text-gray-500">...</span>
        </>
      )}

      {activeInstance?.breadcrumb.historyPages?.map((params, index) => {
        const isLast = index === activeInstance.breadcrumb.historyPages.length - 1;

        return (
          <React.Fragment key={`page-${params.key}-${index}`}>
            <span className="e-icons e-chevron-right text-gray-400 text-xs" />
            <PageItem
              itemIndex={index}
              params={params}
              isLast={isLast}
            />
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default BreadcrumbCustom;
